import { DOMElement } from 'react';
import ScrollMagic, { Controller, Scene } from 'scrollmagic';

/**
 * WMSCM
 * Class to handle Scroll magic library for WM blocks
 */

export default class WMSCM {

	class_hidden: string;

	el_trigger: HTMLElement;

	controller: Controller;

	scene: Scene;

	el_intro: HTMLDivElement;

	el_icon: HTMLDivElement;



	constructor() {

		this.class_hidden = 'wm-invisible';

		this.el_trigger = this.init_el_trigger();
		this.controller = this.init_controller();

		if(this.get_intro())
			this.fire_intro(this.el_icon, this.class_hidden);
	}

	private init_controller (): Controller {

		return new ScrollMagic.Controller();

	}

	
	private init_el_trigger(): HTMLElement {

		let el_trigger = document.createElement('div');

		el_trigger.setAttribute('id', 'wmscm_trigger');

		document.body.appendChild(el_trigger);

		return el_trigger;

	}

	private get_intro(): Boolean {

		this.el_icon = document.querySelector('.icon-scroll');
		this.el_intro = document.querySelector('.wp-block-wm-blocks-intro');

		return ( this.el_icon && this.el_intro ) ? true : false;

	}


	private fire_intro(el_mouse_icon:HTMLDivElement, hide_class:string): Scene {

		el_mouse_icon.classList.remove ( this.class_hidden );

		return (

			new ScrollMagic.Scene({

				triggerElement: el_mouse_icon,
				triggerHook: 0.9, // show, when scrolled 10% into view
				duration: '1000%', // hide 10% before exiting view (80% + 10% from bottom)
				offset: 50, // move trigger to center of element
			}).setClassToggle(el_mouse_icon, hide_class) // add class to reveal
		//.addIndicators() // add indicators (requires plugin)
			.addTo(this.controller)
		);
	}

	private scroll_check():void {

	}

}
